import { useRef, ImgHTMLAttributes } from 'react';

export const Image = ({
  fallbackSrc,
  ...props
}: ImgHTMLAttributes<HTMLImageElement> & {
  /**
   * Fallback sources in case of loadError
   */
  fallbackSrc?: string | string[];
}) => {
  const ref = useRef<HTMLImageElement>();

  return (
    <img
      ref={ref}
      {...props}
      src={
        props.src ||
        (typeof fallbackSrc === 'string'
          ? fallbackSrc
          : Array.isArray(fallbackSrc)
          ? fallbackSrc[0]
          : null)
      }
      onError={() => {
        if (Array.isArray(fallbackSrc)) {
          const idx = fallbackSrc.findIndex((s) => s === ref.current.src);
          if (idx === -1) {
            ref.current.src = fallbackSrc[0];
          }
          if (idx + 1 < fallbackSrc.length) {
            ref.current.src = fallbackSrc[idx + 1];
          }
        } else if (fallbackSrc) {
          if (ref.current.src === fallbackSrc) {
            return;
          }
          if (
            fallbackSrc.startsWith('/') &&
            ref.current.src === `${window.location.origin}${fallbackSrc}`
          ) {
            return;
          }

          ref.current.src = fallbackSrc;
        }
      }}
    />
  );
};
